import type { StateCreator } from 'zustand';

export const organisationSteps = 1;
export type OrgSteps = 1;

export interface OrganisationState {
  orgCurrentStep: number;
  nextOrgStep: () => void;
  prevOrgStep: () => void;
  orgAnswers: Record<string, string>;
  setOrgAnswers: (obj: { questionId: string; stepAns: string }) => void;
}

export const createOrganisationState: StateCreator<OrganisationState> = (set) => ({
  orgCurrentStep: 0,
  orgAnswers: {},
  nextOrgStep: () =>
    set((state) => {
      if (state.orgCurrentStep === organisationSteps - 1) return { ...state };
      return { orgCurrentStep: state.orgCurrentStep + 1 };
    }),
  prevOrgStep: () =>
    set((state) => {
      if (!state.orgCurrentStep) return { ...state };
      return { orgCurrentStep: state.orgCurrentStep - 1 };
    }),
  setOrgAnswers: ({ questionId, stepAns }: { questionId: string; stepAns: string }) =>
    set((state) => {
      return {
        orgAnswers: {
          ...state.orgAnswers,
          [questionId]: stepAns
        }
      };
    })
});
